import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'boolToText'})
export class BoolToTextPipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'Active' : 'Inactive';
    }
}